"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionSelectDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const positionCardTech_1 = require("./positionCardTech");
const PositionMarkerMap_1 = require("./PositionMarkerMap");
const react_ui_1 = require("@pasport/react-ui");
const PositionSelectDialog = ({ visible, onClose, onSubmit, defaultPosition, title }) => {
    const [selectedPosition, setSelectedPosition] = (0, react_1.useState)(defaultPosition);
    (0, react_1.useEffect)(() => {
        if (visible) {
            setSelectedPosition(defaultPosition);
        }
    }, [visible]);
    const handlePointSelection = (point) => {
        console.log("ABC new position selection", point);
        setSelectedPosition({
            objectType: defaultPosition.objectType,
            position: {
                x: point[0], y: point[1]
            },
        });
    };
    const handlePolygonSelectionPoints = (points) => {
        setSelectedPosition({
            objectType: defaultPosition.objectType,
            geometryPoints: points
        });
    };
    /*
    const handleEmptySelection = () => {
        setSelectedPosition({
            objectType: defaultPosition.objectType
        });
    }*/
    return ((0, jsx_runtime_1.jsx)(react_ui_1.Modal, { autoWidth: true, show: visible, onClose: onClose, spacing: 'no-horizontal', children: (0, jsx_runtime_1.jsxs)("div", { className: 'px-1', children: [(0, jsx_runtime_1.jsx)(react_ui_1.CardHeader, { children: title || 'Zvolte pozici na mapě' }), (0, jsx_runtime_1.jsxs)(react_ui_1.CardSection, { glueBottom: true, children: [(0, jsx_runtime_1.jsx)("div", { style: { width: '100%', height: 400, zIndex: 10000 }, children: (0, jsx_runtime_1.jsx)(PositionMarkerMap_1.PositionMarkerMap, { position: defaultPosition, type: defaultPosition.objectType, editable: true, onChangeGeometry: handlePolygonSelectionPoints, onChangePoint: handlePointSelection }) }), (0, jsx_runtime_1.jsxs)("div", { className: 'd-flex justify-content-end pt-2 gap-3', children: [(0, jsx_runtime_1.jsx)(react_ui_1.Button, { color: 'danger', variant: "outlined", onPress: onClose, children: "Zav\u0159\u00EDt" }), (0, jsx_runtime_1.jsx)(react_ui_1.Button, { color: 'success', onPress: () => {
                                        if (selectedPosition)
                                            onSubmit(selectedPosition);
                                    }, disabled: !(0, positionCardTech_1.isPositionSelected)(selectedPosition), children: "Pou\u017E\u00EDt zvolenou pozici" })] })] })] }) }));
};
exports.PositionSelectDialog = PositionSelectDialog;
